import { useQuery } from '@tanstack/react-query';
import { useAuthState } from '../../../context/auth';
import { ApiService } from '../../../services';

export const FEATURE_TOGGLES_QUERY_KEYS = {
  GET_FEATURE_TOGGLES_FOR_USER: 'getFeatureTogglesForUser',
  GET_STATUS_FOR_USER: 'getBetaFeaturesStatusForUser',
  GET_STATUS_FOR_GROUP: 'getBetaFeaturesStatusForGroup',
} as const;

export interface FeatureToggle {
  id: number;
  uniqueName: string;
  description: string;
}

export const useGetFeatureTogglesForUser = () => {
  // This query is called from FeatureToggleStatus which is called even when the user is logged out,
  // in that case we don't want to call the API since the page will try to logout the user again.
  const { accessToken } = useAuthState();
  return useQuery({
    queryKey: [FEATURE_TOGGLES_QUERY_KEYS.GET_FEATURE_TOGGLES_FOR_USER],
    queryFn: () => ApiService.get<FeatureToggle[]>('v1/feature-toggles/').then((response) => response.data),
    enabled: accessToken != null,
  });
};

interface BetaFeatures {
  active: boolean;
  visible: boolean;
}

interface GetBetaFeaturesStatusForGroupProps {
  groupId: number;
}

export const useGetBetaFeaturesStatusForGroup = ({ groupId }: GetBetaFeaturesStatusForGroupProps) => {
  return useQuery({
    queryKey: [FEATURE_TOGGLES_QUERY_KEYS.GET_STATUS_FOR_GROUP, { groupId }],
    queryFn: () =>
      ApiService.get<BetaFeatures>(`v1/feature-toggles/clients/${groupId}`).then((response) => response.data),
    enabled: groupId != null,
  });
};

export const useGetBetaFeatureStatusForUser = () => {
  // This query is checking if the beta features are enabled
  const { accessToken } = useAuthState();
  return useQuery({
    queryKey: [FEATURE_TOGGLES_QUERY_KEYS.GET_STATUS_FOR_USER],
    queryFn: () => ApiService.get<BetaFeatures>('v1/feature-toggles/status').then((response) => response.data),
    enabled: accessToken != null,
  });
};
